// extracted by mini-css-extract-plugin
module.exports = {"customTableWrapperOuter":"CustomTable-customTableWrapperOuter-2OexSd","customTableWrapperInner":"CustomTable-customTableWrapperInner-EuLp9T"};